import { forwardRef, useState, type InputHTMLAttributes } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "./input";
import { useLanguage } from "../../contexts/LanguageContext";

/**
 * 密碼輸入框（2026-08-26）：右側眼睛圖示可切換明碼顯示。
 * 沿用 Input 樣式，只在右側留出圖示空間；type 由內部狀態控制，呼叫端不必給。
 */
export const PasswordInput = forwardRef<HTMLInputElement, Omit<InputHTMLAttributes<HTMLInputElement>, "type">>(
  ({ className, ...props }, ref) => {
    const { t } = useLanguage();
    const [visible, setVisible] = useState(false);
    const label = visible
      ? t({ "zh-TW": "隱藏密碼", "en-US": "Hide password", "zh-CN": "隐藏密码" })
      : t({ "zh-TW": "顯示密碼", "en-US": "Show password", "zh-CN": "显示密码" });

    return (
      <div className="relative">
        <Input ref={ref} type={visible ? "text" : "password"} className={`pr-9 ${className ?? ""}`} {...props} />
        <button
          type="button"
          onClick={() => setVisible((v) => !v)}
          aria-label={label}
          aria-pressed={visible}
          title={label}
          tabIndex={-1}
          className="absolute inset-y-0 right-0 flex w-9 items-center justify-center text-muted-foreground transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          {visible ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
        </button>
      </div>
    );
  },
);
PasswordInput.displayName = "PasswordInput";
